import { render, staticRenderFns } from "./EmbedSidebar.vue?vue&type=template&id=d0b89eda&scoped=true"
import script from "./EmbedSidebar.vue?vue&type=script&lang=js"
export * from "./EmbedSidebar.vue?vue&type=script&lang=js"
import style0 from "./EmbedSidebar.css?vue&type=style&index=0&id=d0b89eda&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b89eda",
  null
  
)

export default component.exports